import { Box, Tooltip } from "@chakra-ui/react";

interface HeaderComingSoonLinkProps {
  label: string;
  className?: string;
}

export const HeaderComingSoonLink = ({
  label,
  className = "nav-link nav-link--disabled",
}: HeaderComingSoonLinkProps) => (
  <Tooltip label="Coming soon" placement="bottom" hasArrow openDelay={200}>
    <Box as="span" className={className} cursor="not-allowed" aria-disabled>
      {label}
    </Box>
  </Tooltip>
);
